import {
  GET_ALL_MUCH_AND_LEARN,
  GET_ALL_THEME_OF_THE_WEEK,
  SESSION_EXPIRED,
} from "../../actionTypes";

const initialState = {
  muchAndLearn: [],
  themeOfTheWeek: [],
  sessionExp: false,
};

export const muchAndLearnMngtReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_ALL_MUCH_AND_LEARN:
      return {
        ...state,
        muchAndLearn: payload.data,
      };

    case GET_ALL_THEME_OF_THE_WEEK:
      return {
        ...state,
        themeOfTheWeek: payload.data,
      };

    case SESSION_EXPIRED:
      return {
        ...state,
        sessionExp: true,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/actions/trainingmanagement/training.reducers.js